<template>
  <div class="main">
    <div class="content">
      <div class="form-row-line">
        <div class="form-field">
          <popup-button button-text="Добавить собственника">
            <add-owner v-on:owner-add="updateLists"> </add-owner>
          </popup-button>
        </div>
      </div>
    </div>
    <get-owners
      v-on:owners-list-update="updateOwners"
      :update-list="updateOwnersList"
    ></get-owners>
  </div>
</template>
<script>
import addOwner from "components/backoffice/owner/add/Owner";
import getOwners from "components/backoffice/owner/get/Owners";

export default {
  name: "Integration",
  components: {
    addOwner,
    getOwners
  },
  data() {
    return {
      updateOwnersList: false
    };
  },
  computed: {},
  methods: {
    updateLists: function() {
      this.updateOwners();
    },
    updateOwners: function() {
      this.updateOwnersList = !this.updateOwnersList;
    }
  },
  created() {}
};
</script>
